import React from 'react';
import { Formik, Form, FieldArray, Field } from 'formik';
import { v4 as uuidv4 } from 'uuid';

import {
  FormContainer,
  FormRow,
  FormRowAlt,
  FormTextInput,
  Delete,
  AddButton,
  SubmitButton,
} from '../../../components';
import { type1CompanyDetailsFormValidationSchema } from '../../../utils';
import { submitType1CompanyDetailsForm } from '../../../api';

const getGstDetailsObj = () => ({
  uuid: uuidv4(),
  gstNumber: '',
  entityName: '',
  new: true,
});

const initialValues = {
  companyName: '',
  companyWebsite: '',
  gstDetails: [getGstDetailsObj()],
  new: true,
};

export const Type1CompanyDetailsForm = ({
  formValue,
  onSuccess,
  onError,
  ...props
}) => {
  const initialFormValues = React.useMemo(() => {
    return formValue?.companyDetails &&
      Object.keys(formValue.companyDetails).length > 0
      ? formValue.companyDetails
      : initialValues;
  }, [formValue]);

  const handleSubmit = async (values) => {
    try {
      console.log(values);
      const { data } = await submitType1CompanyDetailsForm({ form: values });
      console.log(data);
      onSuccess({ msg: 'Saved!' });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Formik
      initialValues={initialFormValues}
      validationSchema={type1CompanyDetailsFormValidationSchema}
      validateOnBlur={false}
      validateOnChange={false}
      validateOnMount={false}
      onSubmit={handleSubmit}
      enableReinitialize={true}
    >
      {({ values, submitForm }) => (
        <Form key={values._id || 'form'}>
          <FormContainer>
            <FormRowAlt>
              <Field
                name="companyName"
                value={values.companyName}
                label="Company Name"
                component={FormTextInput}
                readOnly={values?.new !== true}
              />
              <Field
                name="companyWebsite"
                label="Company Website"
                component={FormTextInput}
                readOnly={values?.new !== true}
              />
            </FormRowAlt>
            <FieldArray name="gstDetails">
              {({ insert, remove }) => {
                return values.gstDetails.map((value, i) => (
                  <React.Fragment key={value.uuid}>
                    <FormRowAlt>
                      <Field
                        name={`gstDetails.${i}.gstNumber`}
                        label="GST Number"
                        component={FormTextInput}
                        readOnly={value?.new !== true}
                      />
                      <Field
                        name={`gstDetails.${i}.entityName`}
                        label="Entity Name"
                        component={FormTextInput}
                        readOnly={value?.new !== true}
                      />
                      {values.gstDetails.length > 1 && value?.new !== true && (
                        <Delete idx={i} remove={remove} />
                      )}
                    </FormRowAlt>
                    {values.gstDetails.length === i + 1 && (
                      <FormRowAlt>
                        <AddButton
                          idx={i}
                          insert={insert}
                          btnText="Add GST Details"
                          rowObj={getGstDetailsObj()}
                        />
                      </FormRowAlt>
                    )}
                  </React.Fragment>
                ));
              }}
            </FieldArray>
            <FormRow>
              <SubmitButton onClick={submitForm} />
            </FormRow>
          </FormContainer>
        </Form>
      )}
    </Formik>
  );
};
